import env from '@polleverywhere/core/lib/env'
import { injectGoogleTagManager } from './google_tag_manager'
require('../foreman_env.js.erb')

const acceptanceExpiryTimeDays = 365
const acceptCookiesKey = 'accept_cookies'

export default class CookieConsentManager {
  static explicitAgree () {
    agreeToCookies('explicit')
  }

  static implicitAgree () {
    agreeToCookies('implicit')
  }

  static clearCookies () {
    document.cookie.split(';')
      .forEach(cookie => {
        const key = cookie.split('=')[0]
        window.console.log('clearCookie', key, domain(), cookie)
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain()}; path=/`
      })
  }
}

const agreeToCookies = (acceptanceMethod) => {
  if (cookiesAccepted()) { return }
  setAcceptCookiesCookie()
  initGoogleTagManager()
  initCutlass()
  trackGoogleClickId()
}

const setAcceptCookiesCookie = () => {
  const expiry = 1000 * 24 * 60 * 60 * acceptanceExpiryTimeDays
  const expires = new Date()
  expires.setTime(expires.getTime() + expiry)
  document.cookie = `${acceptCookiesKey}=1;domain=${domain()};expires=${expires.toUTCString()}`
}

const cookiesAccepted = () =>
  document.cookie.includes(`${acceptCookiesKey}=1`)

const domain = () =>
  location.hostname.split('.').slice(-2).join('.')

const initCutlass = () => {
  const cutlassBaseUrl = env.get('cutlass_base_url')
  if (!cutlassBaseUrl) { return }
  window.cutlassCannon = new window.Cutlass.Cannon(cutlassBaseUrl)
  window.cutlassCannon.trackAll()
}

const initGoogleTagManager = () => {
  const googleTagManagerId = env.get('google_tag_manager_id')
  if (!googleTagManagerId) { return }
  injectGoogleTagManager(googleTagManagerId)
}

const trackGoogleClickId = () => {
  if (!googleClickId() && !googleClickSource()) { return }
  window.cutlassCannon.addEvent('attribution:google_click_id', {
    google_click_id: googleClickId(),
    google_click_source: googleClickSource()
  })
}

const googleClickId = () =>
  urlParams().get('gclid')

const googleClickSource = () =>
  urlParams().get('gclsrc')

const urlParams = () =>
  new URLSearchParams(location.search)
